import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import Typography from 'Components/UI/Typography';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
  root: {},
  messagesLinkContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  messagesLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: theme.palette.facet.primaryBlue,
  },
  messageIconContainer: {
    backgroundColor: theme.palette.facet.primaryBlue,
    borderRadius: theme.radius.md,
  },
  messageIcon: {
    padding: theme.spacing(1),
    color: 'white',
  },
  messageLinkText: {
    marginLeft: theme.spacing(1),
  },
});

const MessageClientLink = ({
  className,
  classes,
  messagesPageLink,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Link
        to={messagesPageLink}
        className={classes.messagesLink}
      >
        <div className={classes.messagesLinkContainer}>
          <div className={classes.messageIconContainer}>
            <ChatBubbleIcon className={classes.messageIcon} fontSize={'large'} />
          </div>
          <Typography variant={'h5'} className={classes.messageLinkText}>{'Send Message'}</Typography>
        </div>
      </Link>
    </Box>
  );
};

MessageClientLink.defaultProps = {
  className: '',
};

MessageClientLink.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  messagesPageLink: PropTypes.string.isRequired,
};

export default withStyles(styles)(MessageClientLink);
